export default "__VITE_ASSET__f2fc7556__"